export const environment = {
  production: true,
  apiUrl: 'https://calcufr8.totalshipping.co.uk/api'
};
